<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://niaga-ku.com" target="_blank" class="footer-brand">Niagaku</a>
      <span class="ml-1">&copy; {{ new Date().getFullYear() }} Niaga-Ku. All rights reserved.</span>
    </div>
    <div class="mfs-auto">
      <span class="mr-1">Built for Malaysian SMEs</span>
      <span v-if="versionLabel" class="footer-version ml-2">{{ versionLabel }}</span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter',
  data() {
    return {
      version: '',
      buildDate: ''
    }
  },
  computed: {
    versionLabel() {
      if (!this.version) return ''
      const isDev = this.version === 'dev'
      const label = isDev ? 'dev' : this.version
      const built = this.buildDate ? this.buildDate.slice(0, 10) : ''
      return built ? `Niagaku ${label} · built ${built}` : `Niagaku ${label}`
    }
  },
  async mounted() {
    try {
      const response = await window.api.get('/version')
      const result = response.data.result || {}
      this.version = result.version || ''
      this.buildDate = result.buildDate || ''
    } catch (e) {
      // Silently ignore: if the version endpoint is unavailable, just hide the label.
    }
  }
}
</script>

<style scoped>
.footer-brand {
  font-weight: 700;
  color: #1e3a5f;
}
.footer-brand:hover {
  color: #10b981;
}
.footer-version {
  font-size: 0.75rem;
  color: #8a93a2;
}
</style>
